import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import SEOHead from "@/components/SEOHead";
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Smartphone, Apple, Monitor } from 'lucide-react';

const InstalarPage = () => {
  return (
    <>
      <SEOHead
        title="Instalar App AI Palpite Guru - Android, iOS e Desktop"
        description="Instale o AI Palpite Guru na tela inicial do seu celular ou computador. Acesso rápido e offline ao sistema de palpites com IA para Jogo do Bicho e Loterias."
        keywords="instalar app jogo do bicho, app palpites bicho, aplicativo jogo do bicho, pwa jogo do bicho"
        canonical="/instalar"
      />
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
          Como Instalar o AI Palpite Guru
        </h1>
        <p className="text-muted-foreground">
          Adicione o app à sua tela inicial para acesso rápido e offline
        </p>
      </div>

      <Tabs defaultValue="android" className="w-full">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="android">
            <Smartphone className="mr-2 h-4 w-4" />
            Android
          </TabsTrigger>
          <TabsTrigger value="ios">
            <Apple className="mr-2 h-4 w-4" />
            iOS
          </TabsTrigger>
          <TabsTrigger value="desktop">
            <Monitor className="mr-2 h-4 w-4" />
            Desktop
          </TabsTrigger>
        </TabsList>

        <TabsContent value="android">
          <Card>
            <CardHeader>
              <CardTitle>Instalar no Android</CardTitle>
              <CardDescription>Chrome, Edge, Samsung Internet</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <p className="font-semibold">Opção 1: Banner Automático</p>
                <ol className="list-decimal list-inside space-y-1 text-muted-foreground">
                  <li>Um banner aparecerá automaticamente na parte inferior</li>
                  <li>Toque em "Instalar Agora"</li>
                  <li>Confirme a instalação</li>
                </ol>
              </div>
              <div className="space-y-2">
                <p className="font-semibold">Opção 2: Menu do Navegador</p>
                <ol className="list-decimal list-inside space-y-1 text-muted-foreground">
                  <li>Toque nos 3 pontos no canto superior direito</li>
                  <li>Selecione "Adicionar à tela inicial" ou "Instalar app"</li>
                  <li>Confirme tocando em "Adicionar"</li>
                </ol>
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="ios">
          <Card>
            <CardHeader>
              <CardTitle>Instalar no iOS</CardTitle>
              <CardDescription>Safari (obrigatório)</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <ol className="list-decimal list-inside space-y-2 text-muted-foreground">
                <li>Abra o site no <strong>Safari</strong> (outros navegadores não funcionam)</li>
                <li>Toque no ícone de <strong>Compartilhar</strong> (quadrado com seta para cima)</li>
                <li>Role para baixo e toque em <strong>"Adicionar à Tela de Início"</strong></li>
                <li>Edite o nome se desejar e toque em <strong>"Adicionar"</strong></li>
                <li>O ícone aparecerá na sua tela inicial</li>
              </ol>
              <div className="bg-yellow-50 dark:bg-yellow-950 p-4 rounded-lg">
                <p className="text-sm text-yellow-800 dark:text-yellow-200">
                  <strong>⚠️ Importante:</strong> No iOS, a instalação só funciona no Safari.
                </p>
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="desktop">
          <Card>
            <CardHeader>
              <CardTitle>Instalar no Desktop</CardTitle>
              <CardDescription>Chrome, Edge, Brave</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <ol className="list-decimal list-inside space-y-2 text-muted-foreground">
                <li>Procure o ícone de <strong>instalação</strong> (⊕ ou computador) na barra de endereços</li>
                <li>Clique no ícone</li>
                <li>Confirme clicando em "Instalar"</li>
                <li>O app abrirá em uma janela separada</li>
              </ol>
              <div className="bg-blue-50 dark:bg-blue-950 p-4 rounded-lg">
                <p className="text-sm text-blue-800 dark:text-blue-200">
                  <strong>💡 Dica:</strong> Você também pode ir em Menu → Mais Ferramentas → Criar Atalho
                </p>
              </div>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
    </>
  );
};

export default InstalarPage;
